import { Table, Text } from '@radix-ui/themes'
import { formatDayWithYear } from '~/utils/date'
import { formatRecipients, isReturnInProgress, type MaterialReturn } from '../service'
import { InstallationIdLinks } from './InstallationIdLinks'
import { LabelExpiryText } from './LabelExpiryText'
import { MarkReturnReceivedButton } from './MarkReturnReceivedButton'
import { ReturnLabelLink } from './ReturnLabelLink'
import { ReturnStatusBadge } from './ReturnStatusBadge'
import { TrackingNumberLink } from './TrackingNumberLink'

interface MaterialReturnsTableProps {
  returns: MaterialReturn[]
}

export const MaterialReturnsTable = ({ returns }: MaterialReturnsTableProps) => {
  if (returns.length === 0) return <Text color="gray">No material returns.</Text>

  return (
    <Table.Root variant="surface">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeaderCell>Status</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Sent</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Organization</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Installations</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Recipient</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Received</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Waybill</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Label expires</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell>Label</Table.ColumnHeaderCell>
          <Table.ColumnHeaderCell />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {returns.map((materialReturn) => (
          <Table.Row key={materialReturn.id}>
            <Table.Cell>
              <ReturnStatusBadge materialReturn={materialReturn} />
            </Table.Cell>
            <Table.Cell>{formatDayWithYear(materialReturn.sent_at)}</Table.Cell>
            <Table.Cell>{materialReturn.org?.name ?? '—'}</Table.Cell>
            <Table.Cell>
              <InstallationIdLinks
                installationIds={materialReturn.installations.map((link) => link.installation_id)}
              />
            </Table.Cell>
            <Table.Cell>{formatRecipients(materialReturn)}</Table.Cell>
            <Table.Cell>
              {materialReturn.received_at ? formatDayWithYear(materialReturn.received_at) : '—'}
            </Table.Cell>
            <Table.Cell>
              <TrackingNumberLink trackingNumber={materialReturn.tracking_number} />
            </Table.Cell>
            <Table.Cell>
              <LabelExpiryText materialReturn={materialReturn} />
            </Table.Cell>
            <Table.Cell>
              <ReturnLabelLink path={materialReturn.label_storage_path} />
            </Table.Cell>
            <Table.Cell>
              {isReturnInProgress(materialReturn) ? (
                <MarkReturnReceivedButton materialReturnId={materialReturn.id} />
              ) : null}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )
}
